import axios from 'axios';
import { BUSINESS_API_BASE_URL } from './endpoint.js';

export const getAllBusinesses = async () => {
    const response = await axios.get(`${BUSINESS_API_BASE_URL}/business/`, {
        withCredentials: true,
        headers: {
            'Content-Type': 'application/json'
        }
    });
    console.log('Fetched businesses:', response.data);
    return response.data.items || response.data;
}

export const getBusinessById = async (businessId) => {
    const response = await axios.get(`${BUSINESS_API_BASE_URL}/business/${businessId}`, {
        withCredentials: true,
        headers: {
            'Content-Type': 'application/json'
        }
    });
    return response.data.items[0];
}

export const getBusinessInfo = async (businessId) => {
    const response = await axios.get(`${BUSINESS_API_BASE_URL}/business/${businessId}/info/`, {
        withCredentials: true,
        headers: {
            'Content-Type': 'application/json'
        }
    });
    return response.data;
}

export const getBusinessCategories = async () => {
    const response = await axios.get(`${BUSINESS_API_BASE_URL}/business/categories`, {
        withCredentials: true,
        headers: {
            'Content-Type': 'application/json'
        }
    });
    console.log("Categories: ", response.data.items);
    return response.data.items;
}